import * as React from 'react';
import {connect} from 'react-redux';

import {Routing} from 'nutshell-core/routing';
import type {Properties} from 'nutshell-core/schema/schema-types';
import type {ListItem, SavedListType} from 'nutshell-core/types';

// @ts-expect-error
import {getListFieldKey} from '../../../dashboard-helpers';
// @ts-expect-error
import * as dashboardSelectors from '../../../dashboard-selectors';

import type {NutshellState} from '../../../../../store';

import {EntityListMini} from './entity-list-mini';
import {EntityListMiniEmptyState} from './entity-list-mini-empty-state';

import styles from './entity-list-mini.module.css';

type OwnProps = {
    list?: {
        value: string;
        reportType: SavedListType;
        htmlUrl: string;
        listItems: ListItem[];
        meta: any;
    };
};

type StateProps = {
    schema: Properties;
};

type Props = OwnProps & StateProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        schema: dashboardSelectors.getLeadsSchema(state),
    };
};

export class ListComponent extends React.Component<Props> {
    render() {
        return <div className={styles.container}>{this.renderContents()}</div>;
    }

    renderContents() {
        if (this.props.list) {
            const {reportType, meta, listItems, htmlUrl, value} = this.props.list;
            const deparamedFilterValue = Routing.deparam(value);
            const type = getListFieldKey(reportType);
            const selectedListFields =
                deparamedFilterValue.fields && deparamedFilterValue.fields[type]
                    ? deparamedFilterValue.fields[type].split(',')
                    : [];
            const sortField = deparamedFilterValue.sort;

            return (
                <EntityListMini
                    htmlUrl={htmlUrl}
                    type={type}
                    schema={this.props.schema}
                    columns={selectedListFields}
                    sortField={sortField}
                    columnLimit={1}
                    meta={meta}
                    listItems={listItems}
                />
            );
        }

        return <EntityListMiniEmptyState hasError={true} />;
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const List = connector(ListComponent);
